import React, { useState } from 'react';
import { Card, Avatar, Typography, Button, Box } from '@mui/material';

const ImageUpload = ({ onImageUpload, acceptedFileTypes = ['image/jpeg', 'image/png'], label = 'Upload Image', avatarSize = 100 }) => {
  const [imageData, setImageData] = useState(null);
  const [filename, setFilename] = useState('');

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFilename(file.name);
      convertToBase64(file);
    }
  };

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
        setImageData(reader.result.split(',')[1]);
    };
    reader.readAsDataURL(file);
  };

  const generatePayload = () => {
    return {
      gift_image: {
        file_str_base64: imageData,
        filename: filename,
      },
    };
  };
  const handleConfirm = () => {
    const payload = generatePayload();
    onImageUpload(payload);
  };

  return (
    <Box sx={{ 
      display: { lg: 'flex'}
    }}>
      <Box sx={{ width: { xs: '100%', lg: '70%' }, }}> 
      <input
        type="file"
        accept={acceptedFileTypes.join(', ')}
        onChange={handleImageChange}
        style={{
          textAlign: 'center',
          padding: '6px',
          borderRadius: '10px',
          border: '1px solid #ccc',
          marginBottom: 2,
          width: '100%',
        }}
      />
      </Box>
      <Button
          variant="outlined"
          color="primary"
          fullWidth
          sx={{marginLeft: { lg: '10px' },
          width: { lg: '30%' }}}
          onClick={handleConfirm}
          disabled={!imageData}
          
      >
        Confirm
      </Button>
    </Box>
  );
};

export default ImageUpload;
